import * as React from "react";
import CredentialSidebar from "../Credential/CredentialSidebar";
import { createBrowserHistory } from "history";
import {
  LoadCredential,
  GetCredentialList,
  CreateCredential,
  UpdateCredential,
  DeleteCredential
} from "../../../../actions/CredentialActions";
import CredentialStore from "../../../../stores/CredentialStore";
import { Link } from "react-router-dom";
import actionTypes from "../../../../actions/ActionTypes";
const customHistory = createBrowserHistory();
class CredentialView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCredential: {
        id: 0,
        name: "",
        type: "",
        clientId: "",
        tenantId: "",
        clientSecret: "",
        username: "",
        password: "",
        secret: ""
      },
      secretId: 0,
      isDirty: false,
      error: "",
      isSaving: false,
      deleteStatus: 0,
      isEncrypted: false,
      clientSecretEncrypted: false,
      passwordEncrypted: false,
      secretEncrypted: false
    };
    this.updateSecret = this.updateSecret.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.deleteCredential = this.deleteCredential.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.editCredential = this.editCredential.bind(this);
  }
  componentDidMount() {
    CredentialStore.addChangeListener(this.onStoreUpdate);
    this.updateSecret();
  }
  componentWillUnmount() {
    CredentialStore.removeChangeListener(this.onStoreUpdate);
  }
  componentDidUpdate() {
    this.updateSecret();
  }
  updateSecret() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let credentialId = parseInt(pathParts[pathParts.length - 1], 10);
    if (credentialId !== 0 && (this.state.currentCredential === void 0 || this.state.currentCredential.id !== credentialId)) {
      LoadCredential(credentialId);
    } else if (credentialId === 0 && this.state.currentCredential !== void 0 && this.state.currentCredential.id !== 0) {
      let credential = {};
      credential.id = 0;
      credential.name = "";
      credential.value = "";
      this.setState({
        currentCredential: credential,
        secretName: ""
      });
    }
  }
  onStoreUpdate() {
    let lastAction = CredentialStore.lastChange();
    if (lastAction === actionTypes.GetCredential) {
      let credential = CredentialStore.getCurrentCredential();
      this.setState({
        currentCredential: credential,
        secretName: credential.name,
        isDirty: false,
        isSaving: false,
        clientSecretEncrypted: true,
        passwordEncrypted: true,
        secretEncrypted: true
      });
    }
    if (lastAction === actionTypes.CredentialCreate) {
      let lastError = CredentialStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newCredential = CredentialStore.getCurrentCredential();
        console.log("NEW CRED");
        console.log(newCredential);
        if (newCredential.id !== this.state.currentCredential.id) {
          customHistory.push(`/Admin/CredentialView/${newCredential.id}`);
        }
        this.setState({
          error: "",
          currentSecret: newCredential,
          currentName: newCredential.name,
          isSaving: false,
          isDirty: false
        });
        GetCredentialList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === actionTypes.CredentialUpdate) {
      let lastError = CredentialStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let updatedCredential = CredentialStore.getCurrentCredential();
        console.log("updated q is q");
        console.log(updatedCredential);
        if (updatedCredential.id !== this.state.currentCredential.id) {
          customHistory.push(`/Admin/CredentialView/${updatedCredential.id}`);
        }
        console.log("are we not updating?");
        this.setState({
          error: "",
          currentCredential: updatedCredential,
          isSaving: false,
          isDirty: false,
          clientSecretEncrypted: true,
          passwordEncrypted: true,
          secretEncrypted: true
        });
        GetCredentialList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === actionTypes.CredentialDelete) {
      let lastError = CredentialStore.getLastError();
      if (lastError === "") {
        let link = document.getElementById("credentialHome");
        link.click();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
  }
  handleNameChange(e) {
    let currentSecret = this.state.currentSecret;
    currentSecret.name = e.target.value;
    this.setState({ currentSecret, isDirty: true });
  }
  editCredential(e, property) {
    let credential = this.state.currentCredential;
    let clientSecretEncrypted = this.state.clientSecretEncrypted;
    let passwordEncrypted = this.state.passwordEncrypted;
    let secretEncrypted = this.state.secretEncrypted;
    switch (property) {
      case "name":
        credential.name = e.target.value;
        break;
      case "type":
        credential.type = e.target.value;
        break;
      case "tenantId":
        credential.tenantId = e.target.value;
        break;
      case "clientId":
        credential.clientId = e.target.value;
        break;
      case "clientSecret":
        credential.clientSecret = e.target.value;
        clientSecretEncrypted = false;
        break;
      case "username":
        credential.username = e.target.value;
        break;
      case "password":
        credential.password = e.target.value;
        passwordEncrypted = false;
        break;
      case "secret":
        credential.secret = e.target.value;
        secretEncrypted = false;
        break;
      default:
        break;
    }
    this.setState({ currentCredential: credential, isDirty: true, clientSecretEncrypted, passwordEncrypted, secretEncrypted });
  }
  //   editType(e) {
  //     console.log('editing type');
  //     console.log(e);
  //     console.log(e.target.value);
  //     let currentCredential = this.state.currentCredential;
  //     currentCredential.type = e.target.value;
  //     this.setState({ currentCredential: currentCredential });
  //   }
  handleValueChange(e) {
    let currentSecret = this.state.currentSecret;
    currentSecret.value = e.target.value;
    this.setState({ currentSecret, isDirty: true });
  }
  handleSaveClick(e) {
    this.setState({ isSaving: true, isEncrypted: false });
    if (this.state.currentCredential.id === 0) {
      CreateCredential(this.state.currentCredential);
    } else {
      UpdateCredential(this.state.currentCredential, this.state.clientSecretEncrypted, this.state.passwordEncrypted, this.state.secretEncrypted);
    }
  }
  //   handleSaveClick2(e) {
  //     this.setState({ isSaving: true, isEncrypted : true });
  //     if (this.state.currentSecret.id === 0) {
  //       CreateCredential(this.state.currentCredential, this.state.isEncrypted);
  //     } else {
  //         UpdateCredential(this.state.currentSecret, this.state.isEncrypted);
  //     }
  //   }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteCredential() {
    console.log("huh?");
    DeleteCredential(this.state.currentCredential.id);
    this.setState({ deleteStatus: 0 });
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(CredentialSidebar, null), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "credentialHome",
        className: "nav-link",
        to: `/Admin/Credential`,
        style: { display: "none" }
      }
    ), this.state.currentCredential !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user-lock" }), "  ", this.state.currentCredential.name)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "nameTxt", className: "form-label" }, "Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "nameTxt",
            value: this.state.currentCredential.name,
            onChange: (event) => this.editCredential(event, "name")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Type:"), /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.currentCredential.type,
            onChange: (event) => this.editCredential(event, "type")
          },
          /* @__PURE__ */ React.createElement("option", { value: "" }),
          /* @__PURE__ */ React.createElement("option", { value: "Microsoft OAuth" }, "Microsoft OAuth"),
          /* @__PURE__ */ React.createElement("option", { value: "Username & Password" }, "Username & Password"),
          /* @__PURE__ */ React.createElement("option", { value: "Secret" }, "Secret")
        )), this.state.currentCredential.type === "Microsoft OAuth" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Tenant Id:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "tenantId",
            value: this.state.currentCredential.tenantId,
            onChange: (event) => this.editCredential(event, "tenantId")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Client Id:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "clientId",
            value: this.state.currentCredential.clientId,
            onChange: (event) => this.editCredential(event, "clientId")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Client Secret:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: this.state.clientSecretEncrypted ? "password" : "text",
            className: "form-control",
            id: "clientSecret",
            value: this.state.currentCredential.clientSecret,
            onChange: (event) => this.editCredential(event, "clientSecret")
          }
        ))), this.state.currentCredential.type === "Username & Password" && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Username:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "username",
            value: this.state.currentCredential.username,
            onChange: (event) => this.editCredential(event, "username")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Password:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: this.state.passwordEncrypted ? "password" : "text",
            className: "form-control",
            id: "password",
            value: this.state.currentCredential.password,
            onChange: (event) => this.editCredential(event, "password")
          }
        ))), this.state.currentCredential.type === "Secret" && /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Secret:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: this.state.secretEncrypted ? "password" : "text",
            className: "form-control",
            id: "secret",
            value: this.state.currentCredential.secret,
            onChange: (event) => this.editCredential(event, "secret")
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: `btn btn-primary ${this.state.isDirty || this.state.isSaving ? "" : "disabled"}`,
            onClick: this.handleSaveClick
          },
          "Save"
        ), !this.state.isDirty && !this.state.isSaving && this.state.currentCredential.id !== 0 && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        ), this.state.isSaving && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", size: "2x", spin: true }), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this credential?"),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger",
              onClick: this.deleteCredential
            },
            "Yes - Delete"
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary",
              style: { marginLeft: "6px" },
              onClick: this.cancelDelete
            },
            "Cancel"
          )
        ), this.state.error !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.error
        )))
      )
    )));
  }
}
export default CredentialView;
